import { createReducer } from '@reduxjs/toolkit';
import { statusFilters } from './constants';
import { addTodo, deleteTodo, toggleCompleted, setStatusFilter } from './actions';

const tasksInitialState = [];

export const tasksReducer = createReducer(tasksInitialState, (builder) => {
  builder
    .addCase(addTodo, (state, action) => {
      const { id, text } = action.payload;
      state.push({ id, text, completed: false });
    })
    .addCase(deleteTodo, (state, action) => state.filter((todo) => todo.id !== action.payload))
    .addCase(toggleCompleted, (state, action) => {
      const todo = state.find((t) => t.id === action.payload);
      if (todo) {
        todo.completed = !todo.completed;
      }
    });
});

const filtersInitialState = {
  status: statusFilters.all,
};

export const filterReducer = createReducer(filtersInitialState, (builder) => {
  builder.addCase(setStatusFilter, (state, action) => {
    state.status = action.payload;
  });
});

